"use strict";
import Handlebars from "handlebars/dist/handlebars.js";

var retLottery = (function () {

    var returnLottery = $('.return-ticket-count'),
        reportsTable = $('.t-reports'),
        dashboard = $('.dashboard');

    if (returnLottery.length > 0) {

        var main = $('#main'),
            returnLotteryData = returnLottery.data(),
            chooseLottery = $('.return-ticket-count .choose-lottery'),
            chooseRound = $('.return-ticket-count .choose-round'),
            lotteryEntriesWrapper = $('.return-ticket-count .lottery-entries-wrapper'),
            chooseLotterySource = $("#return-ticket-count-choose-lottery-template").html(),
            chooseLotteryTemplate = Handlebars.compile(chooseLotterySource),
            chooseRoundSource = $("#return-ticket-count-choose-round-template").html(),
            chooseRoundTemplate = Handlebars.compile(chooseRoundSource),
            lotteryEntriesSource = $("#return-ticket-count-textinput-template").html(),
            lotteryEntriesTemplate = Handlebars.compile(lotteryEntriesSource),
            validationSource = $("#client-validation-template").html(),
            validationTemplate = Handlebars.compile(validationSource),
            responseSuccessSource = $('#response-success-template').html(),
            responseSuccessTemplate = Handlebars.compile(responseSuccessSource),
            submitBtns = returnLottery.find('.submit-btn'),
            responseModal = $('.return-ticket-count .response-modal'),
            cl = new CanvasLoader('loader'),
            viewReportList = $('.return-ticket-count .viewreportlist'),
            returnReport = $("#return-ticket-count-report").html(),
            returnReportTemplate = Handlebars.compile(returnReport);

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);
        cl.show();

        main.on('change', '.return-ticket-count .choose-lottery', getRounds);
        main.on('change', '.return-ticket-count .choose-round', getReturnInputs);
        main.on('click', '.return-ticket-count .submit-btn:not(.disabled)', submitReturnLottery);
        main.on('click', '.return-ticket-count .response-modal .btn', closeModal);

        viewReportList.click(function (e) { e.preventDefault(); });

        setTimeout(function () {
            getLotteries(5);
        }, 200);
    }

    function getLotteries(reattempts) {
        // Clear any old data.
        chooseLottery.find('option:not(:first-child)')
            .remove()
            .end()
            .attr('disabled', 'disabled')
            .trigger("liszt:updated");

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.forms.methods.getLotteries,
            type: "GET",
            cache: false,
            timeout: 20000
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            if (response.Success) {
                if (response.Data.length > 0) {
                    var html = chooseLotteryTemplate(response.Data);
                    chooseLottery.append(html);
                    chooseLottery.removeAttr('disabled').trigger("liszt:updated");
                }
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            if (reattempts > 0) {
                getLotteries(--reattempts);
            }
        }
    }

    function getRounds() {

        resetForm();

        var data = {
            "pageid": SETTINGS.pageid,
            "language": SETTINGS.language,
            "selectedLottery": $(this).val()
        };

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.forms.methods.getRounds,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            if (response.Success) {
                if (response.Data.length > 0) {
                    var html = chooseRoundTemplate(response.Data);
                    chooseRound.append(html);
                    chooseRound.removeAttr('disabled').trigger("liszt:updated");
                }
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
        }
    }

    function getReturnInputs() {
        var data = {
            "getReports": returnLotteryData.getReports,
            "selectedLottery": chooseLottery.val(),
            "selectedRound": $(this).val()
        };

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.forms.methods.getReturnInputs,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            if (response.Success) {
                var html = lotteryEntriesTemplate(response.Data['Articles']),
                    dateLength = response.Data['Articles'].length;

                createReportTable(response.Data['Reports']);



                lotteryEntriesWrapper.hide();

                if (dateLength > 2 && dashboard.length > 0) {
                    lotteryEntriesWrapper.addClass('compressed');
                }

                lotteryEntriesWrapper.html(html)
                    .find('.form-item:nth-child(odd)')
                    .addClass('odd')
                    .end()
                    .show();

                submitBtns.each(function () {
                    $(this).removeAttr('disabled');
                });
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
        }
    }

    function updateReports() {
        var data = {
            "getReports": true,
            "selectedLottery": chooseLottery.val(),
            "selectedRound": chooseRound.val()
        };

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.forms.methods.getReturnInputs,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            if (response.Success) {
                createReportTable(response.Data['Reports']);
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
        }
    }

    function createReportTable(reports) {
        var returnReportList = returnReportTemplate(reports),
            returnLength = $.trim(returnReportList).length;
        if (dashboard.length === 0) {
            if (returnLength > 0) {
                reportsTable.find('tbody').html(returnReportList);

            } else {
                reportsTable.find('tbody').empty();
            }
        }
        if (viewReportList.length > 0) {
            viewReportList.tooltip({
                position: { my: "center bottom", at: "center+5 top-25" },
                tooltipClass: "reportlisttooltip",
                content: function () {
                    return returnReportList;
                }
            });

            viewReportList.show();

        }
    }


    function submitReturnLottery(e) {
        e.preventDefault();

        var $this = $(this),
            inputs = lotteryEntriesWrapper.find('input[type="text"]'),
            returnLotteryNumber = [],
            selectedQuantity = $('input[name=edit-quantity]:checked'),
            validated = false;

        responseModal.show();

        inputs.each(function () {
            var inputName = $(this).attr('name'),
                value = $(this).val();

            if (value > 0) {
                returnLotteryNumber.push({
                    "Key": inputName,
                    "Value": value
                });
                validated = true;
            }
        });

        if (!validated) {
            return showMustReturnAtleastOneError();
        }

        var data = {
            "selectedLottery": chooseLottery.val(),
            "selectedRound": chooseRound.val(),
            "articles": returnLotteryNumber,
            "getReports": returnLottery.data('get-reports'),
            "addtoreport": selectedQuantity.attr('id') === 'add-report'
        };

        submitBtns.each(function () {
            $(this).attr('disabled', 'disabled');
        });

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.forms.methods.postReturnLottery,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            if (response.Success) {
                responseModal.empty().append(responseSuccessTemplate(response.Data));
                updateReports();
            } else {
                displayGenericError(response);
            }

            cl.hide();
        }

        function failHandler(error) {
            //serviceNetworkError(responseModal);			
            cl.hide();
        }
    }

    function closeModal() {
        if (responseModal.find('> div').hasClass('response-success')) {
            resetForm();
            chooseLottery.prop('selectedIndex', 0).trigger("liszt:updated");
        }
        responseModal.hide();

        return false;
    }

    function resetForm() {
        viewReportList.hide();
        lotteryEntriesWrapper.empty();
        chooseRound.find('option:not(:first-child)')
            .remove()
            .end()
            .attr('disabled', 'disabled')
            .trigger("liszt:updated");

        submitBtns.each(function () {
            $(this).attr('disabled', 'disabled');
        });
    }

    function showMustReturnAtleastOneError() {
        responseModal.empty().append(validationTemplate).show();
    }

})();
